// extracted by mini-css-extract-plugin
module.exports = {"container":"WarningModal_container__1ryAN","confirmBtn":"WarningModal_confirmBtn__BMNa3"};